import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getFloorplanBackgroundImage, getOffsetRect } from '../helpers';
import * as ThreeDModelActions from './ThreeDModelActions';
import './Style';

class ThreeDModelWrapperContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            errorInfo: null
        }

        this.playThreeDModelClick = this.playThreeDModelClick.bind(this);
    }

    playThreeDModelClick() {
        this.props.threeDModelActions.navigateToThreeD({
            id: 'threeDModel',
            top: getOffsetRect(this.threeD).top
        });
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    render() {
        const { url, floorplanImagesPath, floorplanStages } = this.props;
        const { error } = this.state;

        if (!url.length || error) {
            return null;
        }

        const floorplanBackgroundImage = getFloorplanBackgroundImage(
            floorplanImagesPath, floorplanStages
        );

        const floorplanImageBlock = floorplanBackgroundImage
            ? (
                <div className="overlay-image-wrapper">
                    <div className="overlay-image">
                    </div>
                    <img src={floorplanBackgroundImage}/>
                </div>
            )
            : null;

        const threeDModelOverlay = (
            <div className="threeDModel-overlay">
                <div className="overlay-content">
                    <div className="overlay-controls">
                        <i
                            className="fa fa-play-circle"
                            onClick={this.playThreeDModelClick}>
                        </i>
                        <p>explore 3d model</p>
                    </div>
                    {floorplanImageBlock}
                </div>
            </div>
        );

        return (
            <div
                id='threeDModel'
                className="threeDModel-wrapper"
                ref={threeD => this.threeD = threeD}>
                <h2 className="section-header">3d floor plan</h2>
                    {threeDModelOverlay}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        url: state.threeDModel.url,
        floorplanImagesPath: state.floorplan.imagesPath,
        floorplanStages: state.floorplan.stages
    }
}

const mapDispatchToProps = (dispatch) => ({
    threeDModelActions: bindActionCreators(ThreeDModelActions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(ThreeDModelWrapperContainer)
